"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enum = _interopRequireDefault(require("../enum"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 枚举类：订单支付方式
 * PageTypeEnum
 */
var _default = exports.default = new _enum.default([{
  key: 'HOME',
  name: '首页',
  value: 10
}, {
  key: 'CUSTOM',
  name: '自定义页',
  value: 20
}]);